import { createFileRoute } from '@tanstack/react-router'
import { requireRole } from '@/lib/auth-guards'
import { ResellerNumbersPage } from '@/features/reseller/pages/numbers'

export const Route = createFileRoute('/_authenticated/reseller/numbers')({
  beforeLoad: requireRole(['reseller', 'admin']),
  component: ResellerNumbersPage,
})
